import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Closebook from "../../../containers/modules/accounting/closebook";

export default function ClosebookRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="closebook"
      index
      element={
        <AccessControl
          name={"Closebook"}
          auth={authUser}
          component={() => <Closebook />}
        />
      }
    />
  );
}
